module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/custom-collective-c5c5981c91db9568af7897e98ba621da.jpg";